<template>
  <div class="al-input" test-id="al-input" :class="[{ caret: icon }, validateState]">
    <b-form-input
      ref="input"
      :class="[size, { invalid: !valid }]"
      :placeholder="placeholder"
      :value="value"
      :default="inputValue"
      :required="required"
      :pattern="pattern"
      :type="type"
      :autocomplete="autocomplete"
      :disabled="disabled"
      :maxlength="maxlength"
      :state="state"
      :debounce="debounce"
      test-id="al-input"
      @input="updateValue"
      @blur="blur"
      @focus="focus"
      @change="$emit('change')"
      @keyup="$emit('keyup')"
      @update="$emit('update')"
    />
    <b-form-invalid-feedback>{{ errorMessage }}</b-form-invalid-feedback>
    <div v-if="icon" class="caret-items">
      <al-icon :icon="icon" @click.prevent.stop="iconClick" />
    </div>
  </div>
</template>

<script>
import { BFormInput } from 'bootstrap-vue';
import AlIcon from '../../inline/icon/AlIcon.vue';

export default {
  components: {
    BFormInput,
    AlIcon
  },
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: null
    },
    autocomplete: {
      type: String,
      default: 'on'
    },
    type: {
      type: String,
      default: 'text'
    },
    disabled: Boolean,
    pattern: {
      type: [String, RegExp],
      default: null
    },
    maxlength: {
      type: [Number, String],
      default: 160
    },
    state: {
      type: Boolean,
      default: null
    },
    debounce: {
      type: Number,
      default: 0
    },
    errorMessage: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      inputValue: null,
      valid: true,
      totalValid: 0
    };
  },
  computed: {
    validateState() {
      if (this.state === null) {
        return '';
      }
      return this.state ? 'is-valid' : 'is-error';
    },
    required() {
      return !!this.pattern;
    }
  },
  methods: {
    updateValue(value) {
      this.$emit('input', value);
    },
    focus(evt) {
      this.$emit('focus', evt);
      this.$refs.input.focus();
    },
    iconClick() {
      this.$emit('icon-click');
    },
    blur(evt) {
      this.$emit('blur', evt);
    },
    keyup(evt) {
      this.$emit('keyup', evt);
    }
  }
};
</script>

<style lang="scss">
$border-radius: 4px;
$input-height: 44px;

$input-sm-height: 36px;

.al-input {
  position: relative;
  width: 100%;

  input {
    border-color: color(white, darken, 2);
    border-radius: $border-radius;
    font-size: 16px;
    height: $input-height;
    line-height: $input-height;
    padding: 12px 9px;

    &::placeholder {
      color: #b0b0b0;
      font-size: inherit;
    }

    &.is-valid:focus {
      border-color: color(green) !important;
      box-shadow: 0 0 0 1px color(green) !important;
      outline-color: color(green) !important;
    }

    &.invalid {
      background-color: color(red, lighten, 4);
      border-color: color(red) !important;

      &:focus {
        border-color: color(red) !important;
        box-shadow: 0 0 0 1px color(red) !important;
        outline-color: color(red) !important;
      }
    }

    &.sm {
      background: #f4f4f4;
      border: 0;
      height: $input-sm-height;
      line-height: $input-sm-height;
      padding: 4.8px 9px;
    }

    /* Chrome, Safari, Edge, Opera */
    &::-webkit-inner-spin-button,
    ::-webkit-outer-spin-button {
      appearance: none;
      margin: 0;
    }
  }

  /* Firefox */
  &[type='number'] {
    appearance: textfield;
  }
}

.al-input.caret {
  input {
    padding-right: 44px;
  }

  .caret-items {
    align-items: center;
    cursor: pointer;
    display: inline-flex;
    height: 100%;
    justify-content: center;
    position: absolute;
    right: 0;
    top: 0;
    visibility: hidden;
    width: 44px;
    z-index: 2;
  }

  &.is-error {
    .caret-items {
      box-sizing: border-box;
      padding-bottom: 22px;
    }
  }

  &:hover {
    input {
      background-image: initial;
    }

    .caret-items {
      visibility: visible;
    }
  }
}
</style>
